import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from '@/router'
import JwtService from "@/common/jwt.service";
import {
  LOGOUT,
  STRIPE_RESET_STATE,
  PAGES_RESET_STATE,
  RESET_STATE
} from "@/store/actions.type";

import {
  SET_LOGGED_IN,RESET_ALL_PAGES_DATA
} from "@/store/mutations.type";
import store from "@/store"

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params)
  },

  get(resource, slug = "") {
    let data = Vue.axios.get(resource+((isNaN(slug) == false && slug != null && slug !==''  )? '/'+slug : (slug.length >0 ? '/'+slug:'')))
     data.catch(error =>{
      if(error.response.status == 401){
        Promise.all([
          store.commit(SET_LOGGED_IN, false),
          store.commit(RESET_ALL_PAGES_DATA),
          store.dispatch(STRIPE_RESET_STATE),
          store.dispatch(PAGES_RESET_STATE),
          store.dispatch(RESET_STATE),
          store.dispatch(LOGOUT),            
        ]).finally(()=>{
          router.push("/login");
          return ;

        })
      }
    })
    
    return data
  },

  post(resource, params) {
    let data =  Vue.axios.post(`${resource}`, params);

    data.catch(error =>{
      if(error.response.status == 401){
        Promise.all([
          store.commit(SET_LOGGED_IN, false),
          store.commit(RESET_ALL_PAGES_DATA),
          store.dispatch(STRIPE_RESET_STATE),
          store.dispatch(PAGES_RESET_STATE),
          store.dispatch(RESET_STATE),
          store.dispatch(LOGOUT),            
        ]).finally(()=>{
          router.push("/login");
          return ;

        })
      }
    })
    
    return data    


  },

  update(resource, slug, params) {
    let data =  Vue.axios.put(`${resource}/${slug}`, params)

    data.catch(error =>{
      if(error.response.status == 401){
        Promise.all([
          store.commit(SET_LOGGED_IN, false),
          store.commit(RESET_ALL_PAGES_DATA),
          store.dispatch(STRIPE_RESET_STATE),
          store.dispatch(PAGES_RESET_STATE),
          store.dispatch(RESET_STATE),
          store.dispatch(LOGOUT),            
        ]).finally(()=>{
          router.push("/login");
          return ;

        })
      }
    })
    
    return data   

  },

  download(resource, slug) {
    let data = Vue.axios.get(`${resource}/${slug}`, {responseType: 'blob'})

    data.catch(error =>{
      if(error.response.status == 401){
        Promise.all([
          store.commit(SET_LOGGED_IN, false),
          store.commit(RESET_ALL_PAGES_DATA),
          store.dispatch(STRIPE_RESET_STATE),
          store.dispatch(PAGES_RESET_STATE),
          store.dispatch(RESET_STATE),
          store.dispatch(LOGOUT),            
        ]).finally(()=>{
          router.push("/login");
          return ;

        })
      }
    })
    
    return data   

  }, 

  put(resource, params) {
    let data = Vue.axios.put(`${resource}`, params);

    data.catch(error =>{
      if(error.response.status == 401){
        Promise.all([
          store.commit(SET_LOGGED_IN, false),
          store.commit(RESET_ALL_PAGES_DATA),
          store.dispatch(STRIPE_RESET_STATE),
          store.dispatch(PAGES_RESET_STATE),
          store.dispatch(RESET_STATE),
          store.dispatch(LOGOUT),            
        ]).finally(()=>{
          router.push("/login");
          return ;

        })
      }
    })
    
    return data   

  },

  delete(resource) {
    let data = Vue.axios.delete(resource)

    data.catch(error =>{
      if(error.response.status == 401){
        Promise.all([
          store.commit(SET_LOGGED_IN, false),
          store.commit(RESET_ALL_PAGES_DATA),
          store.dispatch(STRIPE_RESET_STATE),
          store.dispatch(PAGES_RESET_STATE),
          store.dispatch(RESET_STATE),
          store.dispatch(LOGOUT),            
        ]).finally(()=>{
          router.push("/login");
          return ;

        })
      }
    })
    
    return data   

  }
};

export default ApiService;

export const ModulesService = {
  query(type, params) {
    return ApiService.query("modules/" +type, {
      params: params
    });
  },
  get(slug){
    return ApiService.get("modules", slug); 
  },
  moduleplayer(slug){
    return ApiService.get("modules/view-file", slug); 
  },  
  slide(params) {
    return ApiService.post("user-slides/update" ,params);
  },  
};


export const UsersService = {
  query(type, params) {
    return ApiService.query("users/" +type, {
      params: params
    });
  },
  get(slug){
    return ApiService.get("users",slug); 
  },
  create(params, slug) {
    return ApiService.post("users/"+slug ,params);
  },
  delete(userid) {
    return ApiService.delete("users/"+userid);
  },  
  uploadCSV(params) {
    return ApiService.post("import/Users",params);
  }, 
  downloadFile(slug){
    return ApiService.download("users/",slug)
  },  
};

export const StripeService = {
  get(slug){
    return ApiService.get("stripe",slug); 
  },   
  renewoff(slug){
    return ApiService.get("modules/subscribe-cancel",slug); 
  },   
  saveCard(params){
    return ApiService.query("stripe/add-card", {
      params: params
    })
  }
}

export const CourseService = {
  get(slug){
    return ApiService.get('courses',slug)
  },  
  subscribe(id, params){
    return ApiService.post("courses/subscribe/"+id,params); 
  },  
}

export const VoucherService = {
  get(slug){
    return ApiService.get('vouchers/list/courses',slug)
  },  
  order(params){
    return ApiService.post("vouchers/purchase/courses", params); 
  },  
}

export const CouponService = {
  get(id){
    return ApiService.get('coupons/list/courses?'+id)
  },  
  validate(params){
    return ApiService.get('coupon/validate/courses?'+params)
  },  
  send(params){
    return ApiService.post("coupons/send/courses", params); 
  },
  revoke(id){
    return ApiService.update("coupon/revoke/courses",+id); 
  },  
}

export const TutorVoucherService = {
  get(slug){
    return ApiService.get('vouchers/list/tutor-products',slug)
  },  
  order(params){
    return ApiService.post("vouchers/purchase/tutor-products", params); 
  },  
}

export const TutorCouponService = {
  get(id){
    return ApiService.get('coupons/list/tutor-products?'+id)
  },  
  validate(params){
    return ApiService.get('coupon/validate/tutor-products?'+params)
  },  
  send(params){
    return ApiService.post("coupons/send/tutor-products", params); 
  },
  revoke(id){
    return ApiService.update("coupon/revoke/tutor-products",+id); 
  },  
}

export const TutorProductService = {
  get(slug){
    return ApiService.get('tutor-products',slug)
  },  
  subscribe(id, params){
    return ApiService.post("tutor-products/subscribe/"+id,params); 
  },  
}

export const PagesService = {
  get(slug){
    return ApiService.get('pages',slug)
  },  
}

export const RolesService = {
  get(slug){
    return ApiService.get('roles',slug)
  },  
}

export const LearningSessionService = {
  get(slug){
    return ApiService.get('list-learning-sessions',slug)
  },  
}

export const EquipmentService = {
  get(slug){
    return ApiService.get('equipment',slug)
  },  
  create(params, equipmentid) {
    return ApiService.post("equipment/"+equipmentid ,params);
  },
  delete(equipmentid) {
    return ApiService.delete("equipment/"+equipmentid);
  }, 

}

export const GroupService = {
  get(slug){
    return ApiService.get('groups',slug)
  },  
  getUser(slug){
    return ApiService.get('group-users',slug)
  },  
  create(params, groupid) {
    return ApiService.post("groups/"+groupid ,params);
  },
  delete(groupid) {
    return ApiService.delete("groups/"+groupid);
  }, 

}

export const LanguageService = {
  get(slug){
    return ApiService.get("languages",slug)
  }  
}

export const GeneralDocumentsService =  {
  get(slug){
    return ApiService.get("general-documents",slug)
  },  
  create(params) {
    return ApiService.post("general-documents" ,params)
  }, 
  update(params) {
    return ApiService.post("general-documents/"+params.get('gendoc_id'), params)
  },  
  downloadFile(slug){
    return ApiService.download("general-documents",slug)
  },   
  delete(params) {
    return ApiService.delete("general-documents",params);
  },
}

export const PersonalDocumentsService =  {
  get(slug){
    return ApiService.get("templates/personal",slug)
  },  
  create(params) {
    return ApiService.post("templates/personal" ,params)
  }, 
  update(params) {
    return ApiService.post("templates/personal/"+params.get('temp_id'), params)
  },  
  downloadFile(slug){
    return ApiService.download("templates/personal",slug)
  },    
  delete(params) {
    return ApiService.delete("templates/personal/"+params);
  },
}

export const UserDocumentsService =  {
  get(slug){
    return ApiService.get("user-documents",slug)
  },  
  create(params) {
    return ApiService.post("user-documents" ,params)
  }, 
  update(params) {
    return ApiService.post("user-documents/"+(params.get('ud_id')?params.get('ud_id'):'' ), params)
  },  
  downloadFile(slug){
    return ApiService.download("user-documents",slug)
  },   
  delete(params) {
    return ApiService.delete("user-documents",params);
  },
}


export const ReminderEmailService =  {
  get(slug){
    return ApiService.get("email-templates",slug)
  },  
  create(params) {
    return ApiService.post("email-templates" ,params)
  }, 
  update(params,email_temp_id) {
    return ApiService.post("email-templates/"+email_temp_id, params)
  },  
  delete(params) {
    return ApiService.delete("email-templates/"+params);
  },
}

export const EquipmentGroupService =  {
  get(slug){
    return ApiService.get("equipment-groups",slug)
  },  
  create(params) {
    return ApiService.post("equipment-groups" ,params)
  }, 
  update(params,id) {
    return ApiService.post("equipment-groups/"+id, params)
  },  
  delete(params) {
    return ApiService.delete("equipment-groups/"+params);
  },
}

export const EquipmentTemplate =  {
  get(slug){
    return ApiService.get("templates/equipment",slug)
  },  
  create(params) {
    return ApiService.post("templates/equipment" ,params)
  }, 
  update(params,id) {
    return ApiService.post("templates/equipment/"+id, params)
  },  
  downloadFile(slug){
    return ApiService.download("templates/equipment",slug)
  },  
  delete(params) {
    return ApiService.delete("templates/equipment/"+params);
  },
}

export const TestCaseGroup =  {
  get(slug){
    return ApiService.get("test-case-groups",slug)
  },  
  create(params) {
    return ApiService.post("test-case-groups" ,params)
  }, 
  update(params,id) {
    return ApiService.post("test-case-groups/"+id, params)
  },  
  delete(params) {
    return ApiService.delete("test-case-groups/"+params);
  },
}

export const TestCase =  {
  get(slug){
    return ApiService.get("test-cases",slug)
  },
  downloadFile(slug){
    return ApiService.download("test-cases",slug)
  },    
  create(params) {
    return ApiService.post("test-cases" ,params)
  }, 
  update(params,id) {
    return ApiService.post("test-cases/"+id, params)
  },  
  delete(params) {
    return ApiService.delete("test-cases/"+params);
  },
}

export const TestCaseTemplate =  {
  get(slug){
    return ApiService.get("templates/test-case",slug)
  },
  downloadFile(slug){
    return ApiService.download("templates/test-case",slug)
  },    
  create(params) {
    return ApiService.post("templates/test-case" ,params)
  }, 
  update(params,id) {
    return ApiService.post("templates/test-case/"+id, params)
  },  
  delete(params) {
    return ApiService.delete("templates/test-case/"+params);
  },
}


export const DocumentsService =  {
  get(slug){
    return ApiService.get("documents",slug)
  }
}

export const DashboardService =  {
  get(slug){
    return ApiService.get("dashboard",slug)
  }
}

export const EquipmentLabelsService =  {
  get(slug){
    return ApiService.get("equipment-labels",slug)
  }, 
  delete(slug){
    return ApiService.delete("equipment-labels/"+slug,'')
  },   
  create(params) {
    return ApiService.post("equipment-labels" ,params)
  }, 
  update(params,id) {
    return ApiService.post("equipment-labels"+id, params)
  },  
}



export const CompanySettingsService =  {
  get(slug){
    return ApiService.get("company-settings",slug)
  }, 
  delete(slug){
    return ApiService.delete("company-settings/"+slug,'')
  },   
  post(params, slug) {
    return ApiService.post("company-settings/"+slug ,params)
  }, 
}

export const VideoTutorial = {
  get(slug){
    return ApiService.get("tutorial-videos",slug)
  }, 
}

export const CourseFeedbackService ={
  post(slug, params){
    return ApiService.post("course-test-feedbacks/"+slug,params)
  }
}


export const LogoutService ={
  get(){
    return ApiService.get("logout",'')
  }
}